import { graphql } from '../../../graphql/generated';

export const LAB_ADMIN_LAB_QUERY = graphql(`
  query LabAdminLab {
    assignmentForCurrentUser {
      id
      primaryDoctor {
        id
        assignedLabs {
          lab {
            id
            name
            longName
            shortName
            aiEnabled
          }
        }
      }
    }
  }
`);
